import { css } from '@linaria/atomic';

export const chipContainer = css`
  display: flex;
  align-items: center;
  gap: var(--fabric-number-n-1-px);
  height: 24px;
  max-width: 136px;
  padding: var(--fabric-number-n-0-px) var(--fabric-number-n-2-px);
  border-radius: var(--fabric-number-n-1-px);
  background-color: var(--fabric-color-neutral-00);
  list-style-type: none;
`;

export const chipText = css`
  flex: 1;
  min-width: 0;
`;

export const chipIcon = css`
  flex-shrink: 0;
`;
